// Shared portfolio transform utilities extracted from usePortfolioData
// Keep this module free of React and query-side effects; functions must be deterministic

export interface Fund {
  id: string;
  fund_name?: string;
  display_name?: string;
  sa_asset_class?: string;
  name?: string; // Stock display
  ticker?: string; // Stock ticker
  company_name?: string; // Exchange/company info
  kind?: string; // 'fund' | 'stock' | 'asset' | 'account'
}

export type FundsMap = Record<string, Fund>;

export const getDisplayNameByAssetType = (
  assetType: string | undefined,
  id: string,
  assetsMap: Record<string, any> = {}
): string => {
  // If this is an investment asset and we have its real name in the assetsMap, use it
  if (assetType === 'asset' && assetsMap[id]?.asset_name) {
    return assetsMap[id].asset_name;
  }

  // Otherwise fall back to synthetic names
  if (!assetType) return 'Interim Reference Fund';
  if (assetType.includes('stock')) return `Stock ${id.substring(0, 6)}`;
  if (assetType === 'holding') return `Holding ${id.substring(0, 6)}`; // Fallback for holdings without names
  return 'Interim Reference Fund';
};

export const getTickerByAssetType = (assetType: string | undefined): string => {
  if (!assetType) return 'FUND';
  if (assetType.includes('stock')) return 'STOCK';
  if (assetType === 'holding') return 'HOLDING';
  return 'FUND';
};

export const getCompanyNameByAssetType = (assetType: string | undefined): string => {
  if (!assetType) return 'Fund Company';
  if (assetType.includes('stock')) return 'Stock Exchange';
  if (assetType === 'holding') return 'Alternative Investment';
  return 'Fund Company';
};
